module.exports = __webpack_public_path__ + "resources/img/7@3x.87277592.png";